<div class="edit-container">
    <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="edit-title m-0 p-0">Actualizare drepturi acces Operator</h1>
        <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="add-field">
        <h3>Selectate: {{ selectedProgramIds.length }} din {{ stateRows.length }}</h3>
        <p class="mb-4">Modul > Locație > Serviciu</p>

        <div class="row pb-3" *ngFor="let item of stateRows">
            <mat-checkbox class="group-header" [(ngModel)]="item.checked"
                (change)="updateCheckedList(item, item.checked)" color="primary">
                {{ item.denumire_modul }} > {{ item.denumire_locatie }} > {{ item.denumire_serviciu }}
            </mat-checkbox>
        </div>
    </div>

    <div class="row">
        <div class="col d-flex justify-content-between">
            <button class="btn btn-light" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="btn btn-primary" type="button" mat-flat-button color="primary" [disabled]="isLoading"
                (click)="updateOperator()">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>